import { Box } from "@mui/material";
import { FC } from "react";
import { TabsWithIcons, TabWithIconPanel } from "../TrueUI";
import { BooksIcon, BookIcon } from "../TrueUI/Icons/CustomIcons";

const MaferSandBox: FC = () => {
  return (
    <div
      style={{
        width: "100%",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        rowGap: "50px",
        backgroundColor: "white",
        height: "100%",
      }}
    >
      <TabsWithIcons id="2" name="tabwithicon" tabsWidth="150px">
        <TabWithIconPanel title="TITLE 1" name="1">
          <Box
            sx={{
              width: "100%",
              padding: "20px",
              alignItems: "center",
              rowGap: "50px",
            }}
          >
            Test 1
          </Box>
        </TabWithIconPanel>
        <TabWithIconPanel title="TITLE 2" name="2" icon={<BooksIcon />}>
          <Box
            sx={{
              width: "100%",
              padding: "20px",
              alignItems: "center",
              rowGap: "50px",
            }}
          >
            Test 2
          </Box>
        </TabWithIconPanel>
        <TabWithIconPanel title="TITLE 3" name="3" icon={<BookIcon />}>
          <Box
            sx={{
              width: "100%",
              padding: "20px",
              alignItems: "center",
              rowGap: "50px",
            }}
          >
            Test 3
          </Box>
        </TabWithIconPanel>
      </TabsWithIcons>
    </div>
  );
};

export default MaferSandBox;
